// extracted by mini-css-extract-plugin
module.exports = {"card":"KtOrderCard_card__3Dc__","card-ltr":"KtOrderCard_card-ltr__3QZ1T","order":"KtOrderCard_order__20DK0","right":"KtOrderCard_right__1iRWM"};